import { CheckboxFilterGroup } from '@retail/components';
import { ProductsMessageKey, useProductsTFunction } from '@retail/products/i18n';
import {
  DocumentationFilterDataKey,
  documentationTextMap,
  EnvironmentDataFilterKey,
  environmentFilterDataTextMap,
  PictureFilterDataKey,
  pictureValueTextMap,
} from '@retail/products/utils';
import { useMemo } from 'react';

type InsightFilterDataKey =
  | EnvironmentDataFilterKey
  | DocumentationFilterDataKey
  | PictureFilterDataKey;

const textMapForArea: Record<
  'environment' | 'documentation' | 'picture',
  Record<string, ProductsMessageKey>
> = {
  environment: environmentFilterDataTextMap,
  documentation: documentationTextMap,
  picture: pictureValueTextMap,
};

interface Props {
  label: string;
  insightArea: 'environment' | 'documentation' | 'picture';
  valuesSelected: InsightFilterDataKey[];
  updateFilterValues: (value: string) => void;
}

export function SupplierItemInsightValueFilter({
  label,
  insightArea,
  valuesSelected,
  updateFilterValues,
}: Props) {
  const t = useProductsTFunction();

  const options = useMemo(
    () =>
      Object.entries(textMapForArea[insightArea]).map(([key, textKey]) => ({
        label: t(textKey),
        value: key,
        'aria-label': t('products.mgItem.supplierItem.fieldExists'),
      })),
    [insightArea, t]
  );

  return (
    <CheckboxFilterGroup
      collapsible
      defaultOpen={false}
      label={label}
      options={options}
      selected={valuesSelected}
      onToggle={updateFilterValues}
    />
  );
}
